import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/constants/site";
import UrgencyBar from "@/components/site/UrgencyBar";

const links = [
  { label: "Benefícios", href: "#beneficios", testid: "nav-link-benefits" },
  { label: "Capítulos", href: "#capitulos", testid: "nav-link-chapters" },
  { label: "Depoimentos", href: "#depoimentos", testid: "nav-link-testimonials" },
  { label: "FAQ", href: "#faq", testid: "nav-link-faq" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "border-b border-border/70 bg-background/80 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <UrgencyBar />
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => scrollToId("#inicio")}
          className="flex items-baseline gap-1.5"
        >
          <span className="font-display text-2xl font-bold tracking-tight text-primary">
            Plano
          </span>
          <span className="font-display text-2xl font-bold italic tracking-tight text-accent">
            40+
          </span>
        </button>

        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((link) => (
            <button
              key={link.href}
              data-testid={link.testid}
              onClick={() => scrollToId(link.href)}
              className="group relative text-sm font-medium text-foreground/70 transition-colors duration-300 hover:text-foreground"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-accent transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-cta-button"
          onClick={() => scrollToId("#oferta")}
          className="btn-shine group hidden items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-lg sm:inline-flex"
        >
          Garantir meu ebook
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
        </button>
      </div>
    </header>
  );
};

export default Navbar;
